import { Form } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import InstantSwitch from '../InstantSwitch'
import type { OptionsAPI } from '../useOptions'

const KEYS = ['LogConsumeEnabled']

export default function LogSection({ options }: { options: OptionsAPI }) {
  return (
    <SettingSectionCard title="日志设置" keys={KEYS} options={options} hideSave>
      <Form layout="vertical">
        <Form.Item label="记录消耗日志">
          <InstantSwitch options={options} optionKey="LogConsumeEnabled" defaultChecked />
        </Form.Item>
      </Form>
    </SettingSectionCard>
  )
}
